var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from 'vue';
import { Message } from 'element-ui';
import * as dayjs from 'dayjs';
/**
 * [数据劫持,非装饰器内使用]
 * @param  {any} vm [组件]
 * @param  {string|Array<string>} key [参数]
 * @param  {Boolean} oneWay? [单向数据] [默认双向绑定]
 */
export function def(vm, key, oneWay) {
    var obj = {};
    var keys = [];
    if (typeof key === 'string') {
        keys.push(key);
    }
    else {
        keys = key;
    }
    var _loop_1 = function (i) {
        Object.defineProperty(obj, keys[i], {
            get: function () { return vm[keys[i]]; },
            set: function (newValue) {
                if (!oneWay) {
                    vm[keys[i]] = newValue;
                }
            },
            enumerable: true,
        });
    };
    for (var i = 0; i < keys.length; i++) {
        _loop_1(i);
    }
    return obj;
    // 示例
    // let dataTest = def(this,['testing','testing2']);
    // return { dataTest };
}
/**
 * [遍历]
 * @param  {Object | Array<any>} targe [组件]
 * @param  {Function} cb [回调函数]
 */
export function each(targe, cb) {
    if (Object.prototype.toString.call(targe) === '[object Array]') {
        targe.forEach(function (item, index) {
            cb(item, index);
        });
    }
    else {
        Object.keys(targe).forEach(function (key, index) {
            // @ts-ignore
            cb(targe[key], key, index);
        });
    }
}
/**
 * [是否是数组]
 */
export function isArray(obj) {
    return obj instanceof Array;
}
/**
 * [是否是对象]
 */
export function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * [是否相等]
 * 支持判断数组和对象
 */
export function isEqual(x, y) {
    var res = (x === y);
    if ((isArray(x) && isArray(y)) ||
        (isObject(x) && isObject(y))) {
        var xEntries = Object.entries(x);
        if (xEntries.length === Object.entries(y).length) {
            if (xEntries.length === 0) {
                res = true;
            }
            else {
                res = xEntries.every(function (item) {
                    return isEqual(x[item[0]], y[item[0]]);
                });
            }
        }
    }
    return res;
}
/**
 * [数组内部数据去重]
 * 支持去重数组和对象
 */
export function doWeight(arr) {
    var res = [];
    arr.forEach(function (item) {
        if (isArray(item) || isObject(item)) {
            res.every(function (item2) {
                return !isEqual(item2, item);
            }) && res.push(item);
        }
        else if (res.indexOf(item) === -1) {
            res.push(item);
        }
    });
    return res;
}
/**
 * 合并两个数组成去重数组
 * @param oneArr 数组A
 * @param twoArr 数组B
 * @returns 返回去重数组
 */
export var twoArrayUniqueMerged = function (oneArr, twoArr) {
    return Array.from(new Set(__spreadArrays(oneArr, twoArr)));
};
/**
 * 去除数组A中有数组B的内容
 * @param oneArr 数组A
 * @param twoArr 数组B
 * @returns 返回没有数组B内容的数组A
 */
export var twoArrayExcludeMerged = function (oneArr, twoArr) {
    var arr = new Set(oneArr);
    twoArr.map(function (item) { return arr.delete(item); });
    return Array.from(arr);
};
/**
 * 数组A 与 数组B交集
 * @param oneArr 数组A
 * @param twoArr 数组B
 * @returns 返回没有数组B内容的数组A
 */
export var twoArrayIncludeMerged = function (oneArr, twoArr) {
    var arr = new Set(oneArr);
    return Array.from(arr).filter(function (item) { return twoArr.includes(item); });
};
// 判断值不为空
export function isNotEmpty(value) {
    return value !== '' && value !== null && value !== undefined;
}
export function ArrayIsEqual(arr1, arr2) {
    if (arr1 === arr2) {
        return true;
    }
    else {
        if (arr1.length !== arr2.length) {
            return false;
        }
        else {
            for (var i in arr1) {
                if (arr1[i] !== arr2[i]) {
                    return false;
                }
            }
            return true;
        }
    }
}
/**
 * @description: 替换空值
 * @param {type} value    传入的值
 * @param {type} replacer 被替换的值，默认'-'
 * @return:
 */
export function replaceEmpty(value, replacer) {
    if (replacer === void 0) { replacer = '-'; }
    if (value === '' || value === undefined || value === null) {
        value = replacer;
    }
    return value;
}
/**
 * [日期相关函数方法]
 */
// 计算记忆  减少重复计算   毫秒
// ps:   dateFns.year,dateFns.day
var timeTypes = [
    { value: 'year', unit: '年' },
    { value: 'day', unit: '天' },
    { value: 'hour', unit: '时' },
    { value: 'minute', unit: '分' },
    { value: 'second', unit: '秒' },
];
var DAY_MAP = ['日', '一', '二', '三', '四', '五', '六'];
function dateFn() {
    this.second = 1000;
    this.minute = this.second * 60;
    this.hour = this.minute * 60;
    this.day = this.hour * 24;
    this.year = this.day * 365;
}
// 获取  '01' 格式的日期
// ps:   dateFns.doubleDigit(8)=>'08'
dateFn.prototype.doubleDigit = function (n) {
    // @ts-ignore
    var r = parseInt(n);
    if (r > 9) {
        return r;
    }
    else {
        return '0' + r;
    }
};
// 日期转换
// ps:   dateFns.changeTime(n,'/')=> 2019/09/03 23:59:59
// ps:   dateFns.changeTime(n,null,true)=> 2019-09-03
/* eslint-disable */
dateFn.prototype.changeTime = function (t, divider, nohour) {
    var d = divider || '-'; // 默认分隔符
    if (t) {
        var date = new Date(t);
        var Y = date.getFullYear() + d;
        var M = dateFns.doubleDigit(date.getMonth() + 1) + d;
        var D = dateFns.doubleDigit(date.getDate());
        var h = dateFns.doubleDigit(date.getHours()) + ':';
        var m = dateFns.doubleDigit(date.getMinutes()) + ':';
        var s = dateFns.doubleDigit(date.getSeconds());
        return nohour ? Y + M + D : Y + M + D + ' ' + h + m + s;
    }
    else {
        return '';
    }
};
/* eslint-disable */
dateFn.prototype.durationStr = function (t) {
    var _this = this;
    var res = '';
    timeTypes.forEach(function (item) {
        if (t >= _this[item.value]) {
            // @ts-ignore
            res += (parseInt(t / _this[item.value]) + item.unit);
            t %= _this[item.value];
        }
    });
    return res;
};
dateFn.prototype.getWeekDay = function (t, preStr) {
    if (preStr === void 0) { preStr = ''; }
    return preStr + DAY_MAP[new Date(t).getDay()];
};
export var dateFns = new dateFn();
export function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    var later = function () {
        // 据上一次触发时间间隔
        var last = +new Date() - timestamp;
        // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last);
        }
        else {
            timeout = null;
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args);
                if (!timeout)
                    context = args = null;
            }
        }
    };
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        context = this;
        timestamp = +new Date();
        var callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if (!timeout)
            timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
}
/**
 * 对指定日期进行格式化
 * @param date { Date } 要格式化的日期对象
 * @param pattern { String } 格式化模板，支持 yyyy-MM-dd、yyyy-MM-dd hh:mm:ss等，注意大小写
 */
export var formatDate = function (date, pattern) {
    if (date === void 0) { date = new Date(); }
    if (pattern === void 0) { pattern = 'yyyy-MM-dd'; }
    var o = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    // y+ 指的是匹配y 1次或多次
    // (y+) ()称为捕获括号, 匹配 y+并且捕获匹配项
    // 当pattern中需要有年的时候
    if (/(y+)/.test(pattern)) {
        // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/RegExp
        // RegExp.$1 是被匹配的子字符串,注意,该特性非标准. 不属于当前的任何规范.
        pattern = pattern.replace(RegExp.$1, "" + date.getFullYear()).substr(4 - RegExp.$1.length);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(pattern)) {
            pattern = pattern.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return pattern;
};
/**
 * [深拷贝对象或者数组]
 * @param  {any} obj
 */
export function deepCopy(value) {
    if (Array.isArray(value)) {
        return value.map(deepCopy);
    }
    else if (value && typeof value === 'object') {
        var res = {};
        for (var key in value) {
            res[key] = deepCopy(value[key]);
        }
        return res;
    }
    else {
        return value;
    }
}
/**
 * 判断图片是否存在
 * @param  {[type]}   url  [图片链接]
 * @param  {Function} success [能访问（图片加载完毕后）的回调事件]
 * @param  {Function} error [不能能访问（图片加载失败后）的回调事件]
 * @return {Boolean}           [description]
 */
export function isImage(url) {
    return __awaiter(this, void 0, void 0, function () {
        var ImgObj, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ImgObj = new Image();
                    ImgObj.src = url;
                    result = null;
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            ImgObj.onload = function () {
                                result = true;
                                resolve();
                            };
                            ImgObj.onerror = function () {
                                result = false;
                                reject();
                            };
                        }).finally(function () {
                            // return result;
                        }).catch(function (e) { })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
/**
 * [ellipsisStr 对字符串进行规定长度的省略，超出的部分显示为省略号]
 * @param  {[type]} str [字符串]
 * @param  {[type]} len [规定长度]
 * @return {[type]}     [description]
 */
export function ellipsisStr(str, len) {
    if (len === void 0) { len = 100; }
    if (str === '' || str === null || str === undefined) {
        return str;
    }
    if (!isNaN(len) && len > 0) {
        str = str.length > len ? (str.substr(0, len) + '...') : str;
    }
    return str;
}
/**
 * @description: 计算起止时间相隔月数/天数
 * @param {type} startDate 开始时间 2012-5-10
 * @param {type} endDate 结束时间 2012-5-12
 * @return:
 */
export function handleDiffDays(startDate, endDate) {
    var flag = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
    var start = new Date(startDate);
    var end = new Date(endDate);
    var year = end.getFullYear() - start.getFullYear();
    var month = end.getMonth() - start.getMonth();
    var day = end.getDate() - start.getDate() + 1;
    if (month < 0) {
        year--;
        month = end.getMonth() + (12 - start.getMonth());
    }
    if (day < 0) {
        month--;
        var index = flag.findIndex(function (temp) {
            return temp === start.getMonth() + 1;
        });
        var monthLength = void 0;
        if (index <= 6) {
            monthLength = 31;
        }
        else if (index > 6 && index <= 10) {
            monthLength = 30;
        }
        else {
            monthLength = 28;
        }
        day = end.getDate() + (monthLength - start.getDate()) + 1;
    }
    var result = '';
    if (12 * year + month === 0) {
        result = day + "\u5929";
    }
    else {
        if (day === 0) {
            result = 12 * year + month + "\u4E2A\u6708";
        }
        else {
            result = 12 * year + month + "\u4E2A\u6708" + day + "\u5929";
        }
    }
    return result;
}
export function getSelectionName(value, data, valueKey, labelKey) {
    if (data === void 0) { data = []; }
    if (valueKey === void 0) { valueKey = 'value'; }
    if (labelKey === void 0) { labelKey = 'label'; }
    if (!Array.isArray(data) || data.length === 0) {
        return '';
    }
    var result = '';
    var item = data.find(function (item) { return item[valueKey] === value; });
    if (item) {
        result = item[labelKey];
    }
    return result;
}
/**
 * [isUndef 是否是 null/undefined]
 */
export function isUndef(value) {
    return value === null || value === undefined;
}
/**
 * [contrast 用来处理详情返回参数输出]
 * @param  {[type]} data [数据]
 * @param  {[type]} key [数据内的指针]
 * @param  {[type]} defaultReturn [默认的返回值]
 * @return {[type]} defaultValue [description]
 */
export function contrast(data, key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (!data) {
        return defaultValue;
    }
    var keys = key.split('.');
    if (keys.length > 1) { // 多对象键值对
        var result = null;
        for (var i = 0; i < keys.length; i++) {
            if (i) {
                result = result[keys[i]];
            }
            else {
                result = data[keys[i]];
            }
            if (isUndef(result)) {
                result = defaultValue;
                break;
            }
        }
        return deepCopy(result);
    }
    else { // 1级键值
        return isUndef(data[key]) ? defaultValue : deepCopy(data[key]);
    }
}
/* 判断/处理文件工具函数 */
// 获取文件名后缀名
function stringExtension(str) {
    var ext = null;
    var name = str.toLowerCase();
    var i = name.lastIndexOf('.');
    if (i > -1) {
        ext = name.substring(i);
    }
    // console.log(ext)
    return ext;
}
// // 判断类型Array中是否包含某个值（文件后缀）
// function arrayContain(arr: string | any[], str: string | null) {
//   for (let i = 0; i < arr.length; i++) {
//     if (arr[i] === str) {
//       return true;
//     }
//   }
//   return false;
// }
// 判断文件名的后缀是否存在于传入的文件类型数组中
export function stringExtMatch(str, extType) {
    return extType.includes(stringExtension(str));
}
/**
 * @description: 文件是否支持预览
 * @param {type} name 文件名
 * @param {type} anyFileExt 任何文件都可以被预览，默认true（主要是针对没有文件名的七牛图片）
 * @return:
 */
function fileSupportPreview(name, anyFileExt) {
    // 可预览的文件后缀
    var fileExt = [
        '.png', '.jpg', '.jpeg', '.bmp', '.gif',
        '.txt', '.html',
        '.pdf'
    ];
    return anyFileExt || stringExtMatch(name, fileExt);
}
/**
 * @description: 下载/预览文件
 * @param {type} name 文件名
 * @param {type} url 文件路径
 * @param {type} preview 是否预览，默认直接下载：true 预览，false 直接下载
 * @param {type} downloadUrl 文件下载路径，不传则取自 url
 * @param {type} anyFileExt 是否任何文件都可以被预览，默认true（主要是针对没有文件名的七牛图片）
 * 如果预览文件类型可能有多种情况（可能是 jpg 可能是 excel），需求传入 name 并且设置 anyFileExt = false，根据文件后缀判断文件类型能否被预览
 * @return:
 */
export function downloadFile(_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, url = _a.url, _c = _a.preview, preview = _c === void 0 ? false : _c, downloadUrl = _a.downloadUrl, _d = _a.anyFileExt, anyFileExt = _d === void 0 ? true : _d;
    var isDownload = true;
    // 如果选择预览，通过文件名后缀判断能否预览，不能预览则进行下载
    if (preview && fileSupportPreview(name, anyFileExt)) {
        // console.log('准备预览', url);
        isDownload = false;
    }
    else {
        // console.log('准备下载', downloadUrl);
        isDownload = true;
    }
    var href = isDownload ? (downloadUrl || url) : url;
    var link = document.createElement('a');
    link.setAttribute('href', href);
    link.setAttribute('download', name);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    link.remove();
}
//生成随机字符串
export function randomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}
/**
 * @description: 总和100（total），根据数组前几个key，计算指定key的值（因为对象无法按照预期的顺序进行遍历），并返回填补后的对象
 * @param {type} total    必填，总值，整数，默认100
 * @param {type} obj      必填，对象，至少2个key， { num1: 10, num2: 20, num3: null }，其中 num3 是需要计算的key
 * @param {type} targetKey 选填，指定key
 * @return: calculationLastValue({ num1: 10, num2: 20, num3: null })
 * 已知对象 { num1: 10, num2: 20, num3: null }，计算num3，将返回：
 * { num1: 10, num2: 20, num3: 70 }
 */
export function calculationLastValue(obj, targetKey, total) {
    if (targetKey === void 0) { targetKey = null; }
    if (total === void 0) { total = 100; }
    if (!/^\d*$/.test(String(total))) { // total整数
        return false;
    }
    if (!(obj instanceof Object) || Object.keys(obj).length < 2) { // arr数组，至少2个长度
        return false;
    }
    if (targetKey && obj.hasOwnProperty(targetKey)) { // last_key存在，从数组中剔除，防止后续计算将其算入
        Reflect.deleteProperty(obj, targetKey);
    }
    else { // last_key为空，则last_key默认为数组的最后一个键
        for (var key in obj) {
            targetKey = key;
        }
        Reflect.deleteProperty(obj, targetKey);
    }
    // 如果有值，则累加1，如果大于-1说明填写了值，进行赋值；如果其他key未填写，则赋值null
    var has_data_index = -1;
    var last_value = total;
    for (var key in obj) {
        var item = obj[key];
        if (has_data_index === -1 && item) {
            has_data_index++;
        }
        last_value -= parseFloat(item) || 0;
    }
    // 如果计算出的最后一个值在0-100（total）范围内，赋值给最后一个值
    if (has_data_index > -1 && last_value >= 0 && last_value <= total) {
        obj[targetKey] = last_value;
    }
    else {
        obj[targetKey] = 0;
    }
    return obj;
}
/**
 * @description: 从对象数组中取出ids数组
 * @param {type} arr 数组
 * @param {type} key 对象指向id的key，默认 id
 * @return:
 */
export function getIdsFromArray(arr, key) {
    if (key === void 0) { key = 'id'; }
    return Array.isArray(arr) && arr.length > 0 ? arr.map(function (item) { return item[key]; }) : [];
}
/**
 * @description: 对数组数据以符号分隔显示为字符串
 * @param {type} data      json数组数据，如 data = [{ id: 1, name: '张三' }]
 * @param {type} separator 用于分割的符号，如 separator = '、'
 * @return:
 */
export function parseArrayToString(data, separator) {
    if (data === void 0) { data = []; }
    if (separator === void 0) { separator = '、'; }
    return Array.isArray(data) ? data.join(separator) : '';
}
/**
 * @description: 对json数组数据以符号分隔显示为字符串
 * @param {type} data      json数组数据，如 data = [{ id: 1, name: '张三' }]
 * @param {type} key       提取的键值，如 key = 'name'
 * @param {type} separator 用于分割的符号，如 separator = '、'
 * @return:
 */
export function parseArrayJsonToString(data, key, separator) {
    if (data === void 0) { data = []; }
    if (key === void 0) { key = 'name'; }
    if (separator === void 0) { separator = '、'; }
    var result = '';
    if (data && Array.isArray(data)) {
        result = data.map(function (item) { return item[key]; }).join(separator);
    }
    return result;
}
/**
 * @description: 获取元素距离浏览器顶部、左侧的距离
 * @param {type} node     元素节点
 * @param {type} lastNode 最终元素节点，不传则默认递归到根元素
 * @return:
 */
export function getNodeOffsetToBrowser(node, lastNode) {
    if (!node) {
        return 0;
    }
    var top = node.offsetTop; // 获取该元素相对父容器的上边距
    var left = node.offsetLeft; // 获取该元素相对父容器的左边距
    while (node.offsetParent && node.offsetParent !== lastNode) {
        node = node.offsetParent;
        top += node.offsetTop; // 叠加父容器的上边距
        left += node.offsetLeft; // 叠加父容器的左边距
    }
    return { top: top, left: left };
}
/**
 * @description: 对象数组合并，并去重
 * @param {type} arr1 数组1
 * @param {type} arr2 数组2
 * @param {type} key  去重的唯一key值，默认 id
 * @return:
 */
export function concatJsonArray(arr1, arr2, key) {
    if (key === void 0) { key = 'id'; }
    var hash = {};
    return arr1.concat(arr2).reduce(function (result, cur) {
        var value = cur[key];
        if (value && !hash[value]) {
            hash[value] = true;
            result.push(cur);
        }
        return result;
    }, []);
}
/*
 * originArr不存在于targetArr的数据
 * 如 originArr=a=[1,2,3]，targetArr=b=[2,5]，结果：[1,3]
 * @param  {[type]} originArr [description] 基本数据类型
 * @param  {[type]} targetArr [description] 基本数据类型
 */
export function arrNotExistInTarget(originArr, targetArr) {
    if (!originArr || !targetArr) {
        return false;
    }
    var a = new Set(originArr);
    var b = new Set(targetArr);
    var differenceABSet = new Set(Array.from(a).filter(function (x) { return !b.has(x); }));
    return Array.from(differenceABSet);
}
/**
 * 数字格式化
 * @param {Number} number 整数或者浮点数
 * @param {Boolean} hasPoint true 代表需要小数点 false 代表不需要
 */
export function numberFormatting(number, hasPoint) {
    if (hasPoint === void 0) { hasPoint = true; }
    var strNum = String(number || 0);
    var strNumArr = strNum.split('.');
    var integerNum = strNumArr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    var pointNum = '00';
    if (strNumArr[1] && strNumArr[1].length >= 2) {
        pointNum = strNumArr[1].slice(0, 2);
    }
    else if (strNumArr[1] && +strNumArr[1] < 10) {
        pointNum = strNumArr[1] + '0';
    }
    return hasPoint ? integerNum + '.' + pointNum : integerNum;
}
/**
 * 货币符号
 * @param {Number} number 钱
 * @param {String} symbol 符号
 */
export function moneySign(number, symbol) {
    if (symbol === void 0) { symbol = '￥'; }
    return symbol + number;
}
/**
 * [showInvalidFieldMsg 解析el-form校验未通过的字段信息]
 * @param  {[type]} msgs      未通过校验的字段
 * @param  {[type]} count 提示内容的最大个数，默认 -1无限制
 * @return {[type]}        [description]
 */
export function showInvalidFieldMsg(msgs, count) {
    if (count === void 0) { count = -1; }
    // 遍历未通过校验的字段
    var vm = new Vue(); // 新实例化vue
    var p = vm.$createElement;
    var result = [];
    var index = 0;
    for (var key in msgs) {
        if (count > 0 && index >= count) {
            break;
        }
        var value = msgs[key];
        if (Array.isArray(value)) {
            value.forEach(function (item) {
                result.push(p('div', { style: 'color: #eb9e05' }, item.message));
                index++;
            });
        }
    }
    Message({
        type: 'warning',
        message: p('p', result)
    });
}
/**
* @param {Object} obj  要删除属性的目标对象
* 删除对象的属性值为null或undefined或者''
*/
export function deleteTargetVoid(obj) {
    var result = deepCopy(obj);
    for (var item in result) {
        if (result[item] === null || result[item] === undefined || result[item] === '') {
            Reflect.deleteProperty(result, item);
        }
    }
    return result;
}
/**
 * @description: 对数组进行分组
 * @param {Array} arr
 * @param {Function} fn 将分类的操作权提供给外部
 * @return {*}
 */
export function groupBy(arr, fn) {
    var result = arr.reduce(function (result, item) {
        var groupName = String(fn(item));
        if (!Array.isArray(result[groupName])) {
            result[groupName] = [];
        }
        result[groupName].push(item);
        return result;
    }, {});
    return Object.keys(result).map(function (groupName) {
        return { group_name: groupName, group_list: result[groupName] };
    });
}
/**
 * @description: 获取路由query参数中的ids参数
 * @param {String}} idsString
 */
export function getQueryIds(idsString) {
    var ids = idsString.split(','); // 转为数组
    var idsArr = ids.filter(function (id) { return +id > 0; }); // 过滤出数字字符串
    return idsArr.map(function (id) { return +id; }); // 将数字字符串转为数字
}
export function isIE9() {
    return navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE9.0";
}
/**
 * 页面是否处于 iframe 中
 */
export function inIframe() {
    return self !== top;
}
/**
 * 通过传入下标获取颜色值,不同下标获取不同颜色值,同一下标获取同一颜色值
 * index: 下标
 * initColor: 颜色初始值
 * total: 总共可生成的不重复的颜色值,total越大,下标相近的颜色间的对比越小
 * TODO: initColor,fullColor入参传入#000000等颜色值;
 */
export function getColor(index, total, initColor, fullColor) {
    if (total === void 0) { total = 50; }
    if (initColor === void 0) { initColor = 0xFF0000; }
    if (fullColor === void 0) { fullColor = 0x000000; }
    var idx = index % total;
    if (total === 1)
        return '#' + initColor.toString(16).padStart(6, '0');
    // 将所有颜色平均分成total份
    var perVal = Math.round((initColor - fullColor) / (total - 1));
    // 从浅色开始返回
    var ret = initColor - perVal * idx;
    // 转成RGB 16进制字符串
    return '#' + ret.toString(16).padStart(6, '0');
}
/**
 * @description: 将date-picker时间范围选择器选择的时间进行格式处理，默认格式为YYYY-MM-DD
 * @param {type} time         时间格式的字符串，或能被解析的时间（Tue Aug 08 2017 00:00:00 GMT+0800 (中国标准时间)）
 * @param {type} formatString 转换格式，默认 YYYY-MM-DD
 * @return:
 */
export function filterTime(time, format) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    if (time) {
        // 时间格式处理，默认格式为YYYY-MM-DD
        return dayjs(time).format(format);
    }
    else {
        return '';
    }
}
